export default "/images/28c2ff44ad218283d15435f9be280c2f.avif";